export default "__VITE_ASSET__4506bcb5__"